import { render } from "./DashboardDistribution.vue?vue&type=template&id=d2715fc4&scoped=true"
import script from "./DashboardDistribution.vue?vue&type=script&lang=js"
export * from "./DashboardDistribution.vue?vue&type=script&lang=js"

import "./DashboardDistribution.vue?vue&type=style&index=0&id=d2715fc4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2715fc4"]])

export default __exports__